/* eslint-disable react/no-unescaped-entities */
/* eslint-disable camelcase */
import { Link, graphql, StaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { isProduction } from '../utils/Utils';

var frenchPage
var englishPage
var dutchPage

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isProduction: false };
  }

  componentDidMount() {
    this.setState({
      isProduction: isProduction(),
    });
  }

  WithLocalization
  render () {
    if (typeof window !== `undefined`) {
      this.WithLocalization = !window.location.pathname.includes('/blog')
    }
    const { data } = this.props;
    const { logo, logoLink, whatsNew, products, partners, extraLinks, button, buttonLink } = data?.markdownRemark?.frontmatter || {};

    if (typeof window !== 'undefined') {
      englishPage = window.location.pathname.split('/fr').join('').split('/nl').join('')
      frenchPage = '/fr' + window.location.pathname.split('/fr').join('').split('/nl').join('')
      dutchPage = '/nl' + window.location.pathname.split('/nl').join('').split('/fr').join('')
    }

    return (
      <header>
        <Navbar bg="gray" variant="light" expand="lg" id="top" className="bootyNav">
          <Link to={logoLink}><Navbar.Brand className="ParagonERP">
            <img
              src={logo}
              width="120"
              height="40"
              className="d-inline-block align-top"
              alt="Paragon logo"
            />
          </Navbar.Brand></Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="w-100">
              <div className="navLHS">
                <NavDropdown title={products?.title} id="product-dropdown">
                  <div className="megaMenu">
                    <div className="row">
                      <div className="col-lg-3">
                        <Link to={products?.features?.link}><h6 className="text-uppercase mb-2 blueify">{products?.features?.title}</h6></Link>
                        <ul className="list-unstyled">
                          {
                            (products?.features?.links || []).map((element, index) => (
                              <li key={index} className="nav-item"><Link to={element?.link} className="nav-link text-small pb-0">{element?.linkTitle}</Link></li>
                            ))
                          }
                        </ul>
                      </div>
                      <div className="col-lg-3">
                        <Link to={products?.industries?.link}><h6 className="text-uppercase mb-2 blueify">{products?.industries?.title}</h6></Link>
                        <ul className="list-unstyled mb-4">
                          {
                            (products?.industries?.links || []).map((element, index) => (
                              <li key={index} className="nav-item"><Link to={element?.link} className="nav-link text-small pb-0">{element?.linkTitle}</Link></li>
                            ))
                          }
                        </ul>
                        <Link to={products?.integrations?.link}><h6 className="blueify text-uppercase mb-2">{products?.integrations?.title}</h6></Link>
                        <ul className="list-unstyled">
                          {
                            (products?.integrations?.links || []).map((element, index) => (
                              <li key={index} className="nav-item"><Link to={element?.link} className="nav-link text-small pb-0">{element?.linkTitle}</Link></li>
                            ))
                          }
                        </ul>
                      </div>
                      <Link to={whatsNew?.link} className="col-lg-6 p-0"><div className="promo h-100" style={{ backgroundImage: `url(${whatsNew?.image})` }}>
                        <div className="promoTextbox">
                          <h5>{whatsNew?.title}</h5>
                          <p className="text-white">{whatsNew?.text}</p>
                        </div>
                      </div></Link>
                    </div>
                  </div>
                </NavDropdown>
                <NavDropdown title={partners?.title} id="partners-dropdown">
                  <div className="miniMenu">
                    <div className="row">

                      <div className="col-lg-6">
                        <Link to={partners?.partners?.link}><h6 className="text-uppercase blueify mb-2">{partners?.partners?.title}</h6></Link>
                        <ul className="list-unstyled">
                          {
                            (partners?.partners?.links || []).map((element, index) => (
                              <li key={index} className="nav-item"><Link to={element?.link} className="nav-link text-small pb-0">{element?.linkTitle}</Link></li>
                            ))
                          }
                        </ul>
                      </div>
                      <div className="col-lg-6">

                        <Link to={partners?.integrations?.link}><h6 className="blueify text-uppercase mb-2">{partners?.integrations?.title}</h6></Link>
                        <ul className="list-unstyled">
                          {
                            (partners?.integrations?.links || []).map((element, index) => (
                              <li key={index} className="nav-item"><Link to={element?.link} className="nav-link text-small pb-0">{element?.linkTitle}</Link></li>
                            ))
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                </NavDropdown>
                {
                  (extraLinks || []).map((element, index) => (
                    <a key={index} className="navItem" href={element?.link}>{element?.linkTitle}</a>
                  ))
                }

              </div>

              {this.WithLocalization && (
                <>
                  <Link to={englishPage} className="navItem">EN</Link><Link to={frenchPage} className="navItem">FR</Link> <Link to={dutchPage} className="navItem">NL</Link>
                </> 
              )}
                                <div className="navRHS"> <Link to={this.state.isProduction ? buttonLink : '/smb/signup'}><button className="btn btn-primary mt-1">{button}</button></Link>
                  </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </header>
    )
  }
}
;

Header.propTypes = {
  siteTitle: PropTypes.string
}

Header.defaultProps = {
  siteTitle: ''
}

export default () => (
  <StaticQuery
    query={graphql`
    query headerQuery {
      markdownRemark(frontmatter: {templateKey: {eq: "header"}, language: {eq: "en"}}) {
        frontmatter {
          logo
          logoLink
          whatsNew {
            title
            text
            link
            image
          }
          products {
            title
            features {
              title
              link
              links {
                linkTitle
                link
              }
            }
            industries {
              title
              link
              links {
                linkTitle
                link
              }
            }
            integrations {
              title
              link
              links {
                linkTitle
                link
              }
            }
          }
          partners {
            title
            partners {
              title
              link
              links {
                linkTitle
                link
              }
            }
            integrations {
              title
              link
              links {
                linkTitle
                link
              }
            }
          }
          extraLinks {
            link
            linkTitle
          }
          button
          buttonLink
        }
      }
    }
    `}
    render={(data, count) => <Header data={data} count={count} />}
  />
)
